import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import {showVideoFlag, setVideoSoundItem} from '../../actions';
import {Config, Api} from '../../util';

import LiveVideoItem from '../../components/video/LiveVideoItem';
import LiveImageItem from '../../components/video/LiveImageItem';

let ONAIR_TIMER;

class Division extends Component {
    
  constructor(props){
    super(props);
    this.state={
      activeId: 'video5',
      liveList: []
    };
    this.handleMute = this.handleMute.bind(this);
  }

  componentDidMount(){
  }
  
  
  shouldComponentUpdate(prevProps, prevState){
    if((this.props.display === "DIVISION") || (JSON.stringify(this.state.liveList) !== JSON.stringify(prevState.liveList)) 
    || this.state.activeId !== prevState.activeId )
      return true;
    else return false;
  }

  componentWillReceiveProps(nextProps, nextState){
    if(this.props.selectedMenu !== nextProps.selectedMenu){
      if(nextProps.selectedMenu === "DIVISION"){
        Config.liveImgMode ?
          this.getChList()
          :
          this.getLivePlayInfo();
      }else{
        this.setState({liveList: []});
        clearInterval(ONAIR_TIMER);
        ONAIR_TIMER = undefined;
      }
    }
  }

  componentWillUnmount(){
    this.setState({liveList: []});
    clearInterval(ONAIR_TIMER);
    ONAIR_TIMER = undefined;
  }
  async getLivePlayInfo(){
    try{
      const liveInfo = (await Api.SearchLiveCh()).files.file;
      const liveList = liveInfo.filter(info => info.active === "Y").map(data => {
        return Object.assign({}, {...data, live: true, active: true});
      });
      await this.setState({ liveList });
    }catch(e){
      console.log(e);
    }
  }

  async getChList () {
    try{
      if(!sessionStorage.getItem('chList')){
        const result = await Api.GetChList({chNo: ''}); 
        const useChList = result.files.ch.filter(ch => ch.use === 'Y');
        const chList = _.keyBy(useChList, 'chName');
        sessionStorage.setItem('chList', JSON.stringify(chList));
      }
      const chListObj = JSON.parse(sessionStorage.getItem('chList'));
      ONAIR_TIMER = setInterval(() => {
        this.getImgLoad(chListObj);
      }, 1000);
    } catch(e) {
      console.log(e);
    }
  }

  async getImgLoad(chListObj){
    const tempList = [];
    let time = new Date().getTime();
    for (const property in chListObj) {
        let jsonUrl = `${chListObj[property].urlview}/${property}.json?${time}`;
        let jpgUrl = await fetch(jsonUrl)
        .then((res)=>{
          if(res.ok) return res.json();
          else return; 
        })
        .catch(err => console.log(err));

        jpgUrl = Object.assign({}, {...jpgUrl, chName: property, addr: chListObj[property].urlview, time });
        tempList.push(jpgUrl);
      }
      this.setState({
        liveList: tempList
      });
  }

  

  setLiveSoundItem(id){
    this.setState({activeId: id});
    
  }
  
  handleMute(id, volume){
   if(volume === undefined) {
      this.setState({activeId: id});// this.setLiveSoundItem(id);
    } else {
      if(volume > 0) this.setState({activeId: id}); // this.setLiveSoundItem(id);
    }
  }
    render() {
        const {display} = this.props;
        const {liveList, activeId} = this.state;
        const style = {display: display ? 'flex' : 'none'};
        
        if(Config.liveImgMode){
          return (
            <div className='division video-container' style={style}>
              {liveList.length > 0 && liveList.map((videoItem, index) => {
                return (
                  <Fragment key={index}>
                    <LiveImageItem id={`video${index+5}`} videoItem={videoItem} videoTotalCount={liveList.length}/>
                  </Fragment>
                );
              })
              }
            </div>
        );
            // const {display, videoItem} = this.props;
            // const {liveList, activeId} = this.state;
            // const style = {display: display ? 'flex' : 'none'};
            // console.log(this.props.videoItem);
            // return (
            //     <div className='division video-container' style={style}>
            //       {liveList.length > 0 && (
            //         <Fragment>
            //           <LiveVideoItem id='video5' videoItem={videoItem.video1} handleMute={this.handleMute} activeVideo={activeId} />
            //           <LiveVideoItem id='video6' videoItem={videoItem.video2} handleMute={this.handleMute} activeVideo={activeId} />
            //           <LiveVideoItem id='video7' videoItem={videoItem.video3} handleMute={this.handleMute} activeVideo={activeId} />
            //           <LiveVideoItem id='video8' videoItem={videoItem.video4} handleMute={this.handleMute} activeVideo={activeId} />
            //         </Fragment>
            //         )
            //       }
            //     </div>
            // );
          }else{
            return (
              <div className='division video-container' style={style}>
                {liveList.length > 0 && liveList.map((videoItem, index) => {
                  return (
                    <Fragment key={index}>
                      <LiveVideoItem id={`video${index+5}`} videoItem={videoItem} handleMute={this.handleMute} activeVideo={activeId} videoTotalCount={liveList.length}/>
                    </Fragment>
                  );
                })
                }
              </div>
          );
          }
          
        }
      
}

const mapStateToProps = state => {
    return {
      selectedMenu: state.selectedMenu,
      activeVideo: state.activeVideo,
      // videoItem: state.videoItem,
    }
  };
  const mapDispatcherToProps = dispatch => {
    return {
      showVideoFlag: (videoFlag) => dispatch(showVideoFlag(videoFlag)),
      setVideoSoundItem: (activeVideo) => dispatch(setVideoSoundItem(activeVideo))
    }
  };

Division = connect(mapStateToProps,mapDispatcherToProps)(Division);
export default Division;


// WEBPACK FOOTER //
// ./src/containers/division/index.js